// Canonical permission keys — the dotted paths FE sends to `PermissionRoute` and sidebar
// `isMenuItemHidden`. Must match the server's permissions response shape.
export const PERMISSIONS = {
  // The Pricing Configuration V2 domain, grouped rather than one top-level `create` because mutation
  // rights differ per resource. The whole key can be absent — `lookupPermission` reads that as denied.
  pricing_settings: {
    index: 'pricing_settings.index',
    engines: {
      index: 'pricing_settings.engines.index',
      create: 'pricing_settings.engines.create',
    },
    rate_cards: {
      create: 'pricing_settings.rate_cards.create',
      // Separate from `create`: reading a card's lines out as CSV is granted to two roles that may not
      // write one, so a single write key would deny them a capability they hold.
      export: 'pricing_settings.rate_cards.export',
    },
  },
  bulk_upload: {
    index: 'bulk_upload.index',
    create: 'bulk_upload.create',
  },
  checklists: {
    index: 'checklists.index',
    create: 'checklists.create',
    update: 'checklists.update',
    destroy: 'checklists.destroy',
  },
  legal_entity: {
    index: 'legal_entity.index',
    // Granted more widely than `index`: reading the names out for a picker is not reading the records.
    list: 'legal_entity.list',
    create: 'legal_entity.create',
    update: 'legal_entity.update',
  },
} as const;
